import React, { useContext, useEffect, useRef } from 'react'
import GlobalContext, { defaultValues } from '../GlobalContext';
import ServiceContext from '../ServiceContext'
import CalendarContext from '../CalendarContext'
import socketIO from "socket.io-client";
import defaultPalettes from '../Palettes';
import TextContext from '../TextContext';
import { useNavigate } from 'react-router-dom';

const defCategories = [
    {
      ID: 0,
      cat_name: "nocategory",
      cat_apt: 0,
      cat_color: "#ff00ff",
      loaded: true
    }
  ]

const DataLoader = () => {

    const globalContext = useContext(GlobalContext)
    const serviceContext=useContext(ServiceContext)
    const calendarContext=useContext(CalendarContext)
    const textContext=useContext(TextContext)
    const navigate=useNavigate()
    const alredyLoading=useRef({
        events:false,
        user: false,
        agency: false,
        categories: false,
        customers: false,
        customerRequests: false
    })
    
    const socket = useRef(false)


    const connectSocket = async (shops) =>{
        socket.current = socketIO.connect(globalContext.get.backendUrl)
        console.log('connetti socket')
        socket.current.on('connect', () => {
            console.log('connesso')
            socket.current.emit('shops', { shops: shops })
        })
        socket.current.on('disconnect', (reason)=>{
            console.log('disconnesso')
            globalContext.set(draft => { draft.socket = false})
        })
        socket.current.on('refresh_events', (data) => {
            if(data){
                // console.log('refresh events: ',data)
                globalContext.set(draft => { draft.Reloads.events = data })
            } else {
                // console.log('refresh_events')
                globalContext.set(draft => { draft.Reloads.events = true })
            }
        })
        socket.current.on('refresh_customers', (data) => {
            console.log('refresh_customers')
            if(data){
                console.log(data)
                globalContext.set(draft => { draft.Reloads.customers = data })
            } else {
                console.log('refresh')
                globalContext.set(draft => { draft.Reloads.customers = true })
            }
        })
        socket.current.on('refresh_requests', (data) => {
            console.log('refresh_requests')
            if(data){
                globalContext.set(draft => { draft.Reloads.customerRequests = data })
            } else {
                globalContext.set(draft => { draft.Reloads.customerRequests = true })
            }
        })
        socket.current.on('refresh_users', (data) => {
            console.log('refresh_users')
            if(data){
                globalContext.set(draft => { draft.Reloads.user = data })
            } else {
                globalContext.set(draft => { draft.Reloads.user = true })
            }
        })
        globalContext.set(draft => { draft.socket = socket.current })
    }
    const loadManager = async () => {
        if (globalContext.get.Reloads.agency && !alredyLoading.current.agency) {
            alredyLoading.current.agency=true
            loadAgency()
        }
        if (globalContext.get.Reloads.categories && !alredyLoading.current.categories) {
            alredyLoading.current.categories=true
            loadCategories()
        }
        if (globalContext.get.Reloads.customers && !alredyLoading.current.customers) {
            alredyLoading.current.customers=true
            if(globalContext.get.Reloads.customers.ID){
                if(globalContext.get.Reloads.customers.Elimination){
                    // console.log('remove')
                    removeCustomer()
                } else {
                    // console.log('add')
                    addCustomer()
                }
            } else {
            // console.log('reload')
            loadCustomers()
            }
        }
        if (globalContext.get.Reloads.user && !alredyLoading.current.user) {
            alredyLoading.current.user=true
            if(globalContext.get.Reloads.user.ID){
                if(globalContext.get.Reloads.user.ID==globalContext.get.User.ID){
                    // console.log('remove')
                    loadUsers()
                } else {
                    // console.log('add')
                    addUser()
                }
            } else { 
                loadUsers()
            }
        }
        // if (globalContext.get.Reloads.customerRequests && !alredyLoading.current.customerRequests) {
        //     alredyLoading.current.customerRequests=true
        //     if(globalContext.get.Reloads.customers.ID){
        //         if(globalContext.get.Reloads.customers.Elimination){
        //             // console.log('remove')
        //             removeCustomerRequest()
        //         } else {
        //             // console.log('add')
        //             addCustomerRequest()
        //         }
        //     } else {
        //     // console.log('reload')
        //     loadCustomerRequests()
        //     }
        // }
    }
    const loadAgency = async () => {
        serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading + 1 })
        const resp = await fetch(`${globalContext.get.backendUrl}/papiv1/agencys`, {
            method: 'GET',
            credentials: 'include',
        })
        const respValue = await resp.json()

        if (resp.status == 200) {
            globalContext.set(draft => { draft.Agency = respValue.data; draft.Reloads.agency = false })
            loadOpenings()
        } else if (resp.status == 401){
            logout()
        }
        serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading - 1 })
        alredyLoading.current.agency=false
    }
    const loadOpenings=async()=>{
        serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading + 1 })
        const resp = await fetch(`${globalContext.get.backendUrl}/papiv1/openings`, {
            method: 'GET',
            credentials: 'include',
          })
          const respValue = await resp.json()
          
          if (resp.status == 200) {
            globalContext.set(draft => { draft.openings = respValue.data })
            calendarContext.set(draft=>{draft.resetOpenDates=true})
          } else if (resp.status == 401){
            logout()
        }
          serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading - 1 })
    }
    const loadCategories = async () => {
        serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading + 1 })
        const resp = await fetch(`${globalContext.get.backendUrl}/papiv1/categorys`, {
            method: 'GET',
            credentials: 'include',
        })
        const respValue = await resp.json()

        if (resp.status == 200) {
            globalContext.set(draft => { draft.categories = defCategories.concat(respValue.data); draft.Reloads.categories = false })
            calendarContext.set(draft=>{draft.refreshCategories=true})
        } else if (resp.status == 401){
            logout()
        }
        serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading - 1 })
        alredyLoading.current.categories=false
    }
    const loadCustomers = async () => {
        serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading + 1 })
        const resp = await fetch(`${globalContext.get.backendUrl}/papiv1/customers`, {
            method: 'GET',
            credentials: 'include',
        })
        const respValue = await resp.json()

        if (resp.status == 200) {
            globalContext.set(draft => { draft.customers = respValue.data; draft.Reloads.customers = false })
        } else if (resp.status == 401){
            logout()
        }
        serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading - 1 })
        alredyLoading.current.customers=false
    }
    const addCustomer=()=>{
        const customer=JSON.parse(JSON.stringify(globalContext.get.Reloads.customers))
        globalContext.set(draft => { 
            draft.customers = [...draft.customers.filter(cus=>cus.ID!=customer.ID), customer]; 
            draft.Reloads.customers = false ;
        })
        alredyLoading.current.customers=false
    }
    const addUser=()=>{
        const user=JSON.parse(JSON.stringify(globalContext.get.Reloads.user))
        let shop=JSON.parse(JSON.stringify(globalContext.get.shops.filter(sho=>sho.ID==user.Shop_ID)))
        if(shop.length>0){
            shop=shop[0]
        } else {
            loadUsers()
            return
        }
        const userList=shop.Users.filter(us=>us.ID!=user.ID)
        userList.push(user)
        shop.Users=userList
        globalContext.set(draft => { 
            draft.shops = [...draft.shops.filter(sho=>sho.ID!=user.Shop_ID), shop]; 
            draft.Reloads.user = false ;
        })
        alredyLoading.current.user=false
    }
    const removeCustomer=()=>{
        const customer=JSON.parse(JSON.stringify(globalContext.get.Reloads.customers))
        globalContext.set(draft => { 
            draft.customers = draft.customers.filter(cus=>cus.ID!=customer.ID); 
            draft.Reloads.customers = false ;
        })
        alredyLoading.current.customers=false
    }
    // const loadCustomerRequests = async () => {
    //     serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading + 1 })
    //     const resp = await fetch(`${globalContext.get.backendUrl}/papiv1/CustomerRequests`, {
    //         method: 'GET',
    //         credentials: 'include'
    //     })
    //     const respValue = await resp.json()

    //     if (resp.status == 200) {
    //         globalContext.set(draft => { draft.customerRequests = respValue.data; draft.Reloads.customerRequests = false })

    //     } else {
    //         console.log(resp.status)
    //         console.log(respValue)
    //     }
    //     serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading - 1 })
    //     alredyLoading.current.customerRequests=false
    // }
    // const addCustomerRequest=()=>{
    //     const cusReq=JSON.parse(JSON.stringify(globalContext.get.Reloads.customerRequests))
    //     globalContext.set(draft => { 
    //         draft.customers = [...draft.customers.filter(cus=>cus.ID!=cusReq.ID), cusReq]; 
    //         draft.Reloads.customerRequests = false ;
    //     })
    //     alredyLoading.current.customerRequests=false
    // }
    // const removeCustomerRequest=()=>{
    //     const cusReq=JSON.parse(JSON.stringify(globalContext.get.Reloads.customerRequests))
    //     globalContext.set(draft => { 
    //         draft.customerRequests = draft.customerRequests.filter(cus=>cus.ID!=cusReq.ID); 
    //         draft.Reloads.customerRequests = false ;
    //     })
    //     alredyLoading.current.customerRequests=false
    // }
    const loadUsers = async () => {
        serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading + 1 })
        const resp = await fetch(`${globalContext.get.backendUrl}/papiv1/users`, {
            method: 'GET',
            credentials: 'include',
        })
        const respValue = await resp.json()

        if (resp.status == 200) {
            const user = {
                ID: respValue.data.ID,
                use_username: respValue.data.use_username,
                use_message: respValue.data.use_message,
                use_language: respValue.data.use_language,
                use_message_time: respValue.data.use_message_time,
                use_calendar_start: respValue.data.use_calendar_start,
                use_calendar_end: respValue.data.use_calendar_end,
                use_calendar_hour_format: respValue.data.use_calendar_hour_format,
                use_round_corner: respValue.data.use_round_corner,
                use_palette_ID: respValue.data.use_palette_ID,
                use_palette_name: respValue.data.use_palette_name,
                use_last_read: respValue.data.use_last_read,
                use_gapi_logged: respValue.data.use_gapi_logged,
                use_color: respValue.data.use_color,
                Palettes: respValue.data.Palettes,
                Groups: respValue.data.UserGroups.map(ug => ug.Group)
            }
            //console.log(user)
            if (user.use_palette_ID) {
                const Theme = {
                    name: respValue.data.Palettes.filter(pal => pal.ID == user.use_palette_ID)[0].pal_name,
                    palette: [
                        respValue.data.Palettes.filter(pal => pal.ID == user.use_palette_ID)[0].color_1,
                        respValue.data.Palettes.filter(pal => pal.ID == user.use_palette_ID)[0].color_2,
                        respValue.data.Palettes.filter(pal => pal.ID == user.use_palette_ID)[0].color_3,
                        respValue.data.Palettes.filter(pal => pal.ID == user.use_palette_ID)[0].color_4,
                        respValue.data.Palettes.filter(pal => pal.ID == user.use_palette_ID)[0].color_5,
                        respValue.data.Palettes.filter(pal => pal.ID == user.use_palette_ID)[0].color_6,
                        respValue.data.Palettes.filter(pal => pal.ID == user.use_palette_ID)[0].color_7,
                    ],
                    text_font: respValue.data.Palettes.filter(pal => pal.ID == user.use_palette_ID)[0].Font.fon_text,
                    title_font: respValue.data.Palettes.filter(pal => pal.ID == user.use_palette_ID)[0].Font.fon_title,
                    text_size: respValue.data.Palettes.filter(pal => pal.ID == user.use_palette_ID)[0].Font.fon_size,
                }
                //console.log("shops", respValue.data.Shops)
                globalContext.set(draft => { 
                    draft.Reloads.user = false; 
                    draft.Reloads.events = true;
                    draft.User = user; 
                    draft.Shop = respValue.data.Shop; 
                    draft.shops = respValue.data.Shops; 
                    draft.selectedShop = respValue.data.Shop; 
                    draft.Theme = Theme; })
            } else {
                //console.log("shops", respValue.data.Shops)
                globalContext.set(draft => { 
                    draft.Reloads.user = false; 
                    draft.Reloads.events = true;
                    draft.User = user; 
                    draft.Shop = respValue.data.Shop; 
                    draft.shops = respValue.data.Shops; 
                    draft.selectedShop = respValue.data.Shop; 
                    draft.Theme = defaultPalettes.filter(pal => pal.name == user.use_palette_name)[0] })
            }
        } else if (resp.status == 401){
            logout()
        }
        if(respValue.data.use_language!==null){
            textContext.set(draft=>{draft.activeLang=respValue.data.use_language})
        }
        serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading - 1 })
        alredyLoading.current.user=false
    }
    const logout= ()=>{
        globalContext.set(defaultValues)
        navigate('/')
    }
    

    useEffect(()=>{
        loadManager()
        if(globalContext.get){
            if(globalContext.get.socket===undefined&&globalContext.get.User.ID){
                const shops = globalContext.get.shops.map(sho => sho.ID)
                connectSocket(shops);
            }
        }
    },[globalContext.get])
    

  return (
    <></>
  )
}

export default DataLoader

